export enum BannerTexts {
  WELCOME = "Welcome to the Online Justice user section!",
  BUSINESS_DESCRIPTION = `We're here to provide Cyber Intelligence to help with your scammers. 
This platform is your hub for communication—upload evidence, review services, and track progress. Built on trust, transparency, and communication, it’s designed for your needs. 
Have questions? We're here to help!`,
  SCAMMERS_LIBRARY = "Scammers Library",
  WELCOME_BACK = "Welcome back,",
  THANK_YOU_BACK = "Thank you for coming back!",
  IDENTITY_THEFT_CHECKER = "Identity Theft Checker",
  IDENTITY_THEFT_CHECKER_DESCRIPTION = "This tool will allow you to search across multiple data bases to see if your email address has been compromised.",
  SCAMMERS_LIBRARY_DESCRIPTION = "You can use this tool to search for names and websites of fraudulent companies and see if you've been targeted by any that we are familiar with",
  GENERATE_PASSWORD_TITLE = "Generate Password",
  GENERATE_PASSWORD_TEXT = "Need a strong password? Create complex passwords that will keep your information safe.",
  WALLET_WATCHLIST_TITLE = "New Wallet",
  WALLET_WATCHLIST_DESCRIPTION = "You can use this tool to track a crypto wallet (Bitcoin, Tron, or Ethereum), and see if your stolen money moved anywhere. Our system will check the wallet every 15 minutes, and send you an email notification if anything changed!",
}

export enum FileUploadTexts {
  SELECT_FILES = "Select Files to Upload",
  DRAG_DROP = "or Drag and Drop",
}

export enum DataGridText {
  NO_ROWS = "No rows",
  NO_FILES = "No Files",
  NO_REQUESTS = "No Requests",
  NO_SCAMMERS = "No Scammers",
  NO_WATCHLIST_ITEMS = "No Watchlist Items",
  NO_BILLINGS = "No Billings",
}

export enum ScammersLibraryText {
  BANNER_INPUT_PLACEHOLDER = "Search Name or Domain",
  BANNER_EMAIL_PLACEHOLDER = "Search Eamil",
  SCAMMERS_LIBRARY = "Scammers Library",
}

export enum SectionTitles {
  PRODUCTS_AND_SERVICES = "Products & Services",
}

export enum GeneralButtonLabel {
  SUBMIT = "Submit",
  SEARCH = "Search",
  SIGNIN = "Sign in",
}

export enum SupportText {
  HAVE_QUESTIONS = "Have questions?",
  WERE_HERE_TO_HELP = "We׳re here to help!",
}

export enum ProductFormText {
  PURCHASE_FORM = "Purchase Form",
  FILL_DETAILS = "Fill in your details",
}

export enum UploadedFilesText {
  UPLOADED_FILES = "Uploaded Files",

  NO_FILES = "No Files",
}

export enum DialogText {
  DELETE_FILE_TITLE = "Delete a file",
  DELETE_FILE_TEXT = "Are you sure you want to delete this file?",
  DELETE_WATCH_ITEM_TITLE = "Delete a watch item",
  DELETE_WATCH_ITEM_TEXT = "Are you sure you want to delete this watch item?",
  ADD_WALLET = "Add Wallet Address",
  WALLET_TYPE = "Wallet Type",
  WALLET_ADDRESS = "Wallet Address",
  CONFIRM = "Confirm",
  CANCEL = "Cancel",
  YES = "Yes",
  NO = "No",
}

export enum ErrorMsg {
  UNAUTHENTICATED = "User is not authenticated",
}

export enum SnackbarMsg {
  WRONG_CREDENTIALS = "Email or Password are incorrect...",
  SNACKBAR_DELETE = "File deleted successfully",
  SNACKBAR_FILES_UPLOADED = "Files was uploaded successfully",
  FORM_SUBMIT = "Form submited successfully!",
  SOMETHING_WRONG = "Something went wrong, try again later..",
  LOGIN = "Login successful! ",
  PASSWORD_COPY = "Password copied to clipboard",
  PASSWORD_CHANGED = "Password changed successfully",
}

export enum LoginPageText {
  WELCOME = "Welcome to Online justice Client Portal",
  DIGITAL_DASHBOARD = "Your Digital Dashboard",
  FORGOT_PASSWORD = "Forgot your password?",
  RESET_PASSWORD = "RESET YOUR PASSWORD",
  RESET_PASSWORD_TITLE = "Reset Your Password",
  RESET_PASSWORD_INSTRUCTIONS = "Please fill your email to reset your password",

  NO_ACCOUNT = "Dont have an account?",
  FILL_DETAILS = "Fill in your details here",
}

export enum LoginPageIntroCards {
  TOOL_SET = "Comprehensive Tool Set",
  TOOL_SET_DESCRIPTION = "Wide array of specialized tools for recovering stolen funds, including tracking software, forensic analysis tools, and legal resources.",
  ORDERING_PROCESS = "Seamless Ordering Process",
  ORDERING_PROCESS_DESCRIPTION = "Effortless system for selecting and purchasing tools, ensuring quick access to necessary resources.",
  ORDER_TRACKING = "Transparent Order Tracking",
  ORDER_TRACKING_DESCRIPTION = "Real-time tracking lets users monitor order progress, ensuring clear visibility into each tool's status.",
  ROUND_THE_CLOCK = "Round-the-Clock Support",
  ROUND_THE_CLOCK_DESCRIPTION = "24/7 support staffed by knowledgeable professionals for assistance with tools, order updates, and recovery guidance.",
}

export enum ClientDashboardText {
  PRODUCT_REQUEST = "Product Request",
}
export enum GeneratePasswordText {
  GENERATE_PASSWORD = "Generate Password",
}
export enum WalletWatchlistText {
  ADD_NEW_WALLET = "Add New Wallet",
}

export enum Weekdays {
  SUNDAY = "Sunday",
  MONDAY = "Monday",
  TUESDAY = "Tuesday",
  WEDNESDAY = "Wednesday",
  THURSDAY = "Thursday",
  FRIDAY = "Friday",
  SATURDAY = "Saturday",
}

export const shiftText = {
  morning: "%start% until %end%",
  night: "%start% until %end%",
  notAvailable: "Not available",
  dayoff: "Dayoff",
  morningAvailability: "Available today until 3:00 PM",
  nightAvailability: "Available today until 17:00 AM",
};

export enum AgentText {
  PROFESSIONAL_AGENT = "Professional agent",
  CONTACT_ME = "Contact me",
  SEND_EMAIL = "Send email",
  AVAILABLE_HOURS = "Available hours",
}

export enum ContactUsText {
  CONTACT_US = "Contact Us",
  CONTACT_US_BANNER_TITLE = "Hello, how can we help?",
  FAQ = "FAQ׳s",
  FAQ_SUBTITLE = "Let us help answer the most common questions",
  QUESTIONS = "Questions",
  STILL_QUESTION = "You still have a question?",
  STILL_QUESTION_SUBTITLE = "If you cannot find the question in our FAQ, you can always contact us. We will answer to you shortly!",
  PHONE_NUMBER = "+1902-901-5915",
  EMAIL = "Support@onlinejustice.com",
  HAPPY_HELP = "We are always happy to help!",
  BEST_WAY = "Best way to get answer faster!",
}
export enum SettingsPageText {
  PROFILE = "Profile",
  BILLING = "Billing",
  NOTIFICATIONS = "Notifications",
  SECURITY = "Security",
  YOUR_INFO = "Your information",
  FULL_NAME = "Full Name",
  EMAIL = "Email",
  PHONE = "Phone",
  OTHER_PHONE = "Other Phone",
  GENERAL_UPDATES = "General Updates",
  GENERAL_UPDATES_DESCRIPTION = "Notifications to all customers in the system, updates regarding the system, new tools, etc.",
  PERSONAL_UPDATES = "Personal Updates",
  PERSONAL_UPDATES_DESCRIPTION = "Notifications regarding the progress of a particular order.",
  CURRENT_PASSWORD = "Current Password",
  NEW_PASSWORD = "New Password",
  REPEAT_NEW_PASSWORD = "Repeat New Password",
}

export enum AppHeaderText {
  NOTIFICATIONS = "Notifications",
  CALL_REQUEST_AGENT = "Call Request from agent",
}

export enum ClientRequestText {
  CLIENT_REQUESTS = "Client Requests",
  CLIENT_REQUESTS_DESCRIPTION = `Tracking previous messages you've sent us`,
}
